import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GetApplicationsMarathonsExcelParams } from "api/api/applicationsApi/types";

export const getApplicationsMarathonsExcel = createAsyncThunk<
  void,
  GetApplicationsMarathonsExcelParams
>(
  "applications/getApplicationsMarathonsExcel",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.getApplicationsMarathonsExcel({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting applications marathons excel",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while getting applications marathons excel",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
